import { useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import styles from "./PointButtonPage.module.css";
import "../../fonts/Futura-PT-Book.ttf";

import img_01 from "../../assets/images/simple_helper_pages/1.png";

import img_02 from "../../assets/images/simple_helper_pages/2.png";

import img_03 from "../../assets/images/simple_helper_pages/3.png";

import img_04 from "../../assets/images/simple_helper_pages/4.png";

import img_05 from "../../assets/images/simple_helper_pages/5.png";
const PointButtonPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.head01}>POINT</div>
        <div className={styles.text01}>写真を配置する時のポイント</div>
        <div className={styles.head_tag01_wrapper}>
          <div className={styles.head_tag01}>台紙</div>
        </div>

        <div className={styles.wrapper01}>
          <div className={styles.text02}>
            お子様の視線や体の向きが内側を向くように配置すると、まとまりが良くなります
          </div>
          <img src={img_01} className={styles.img01} alt="img" />
          <div className={styles.text03}>
            三面台紙は、サイドをソロ写真、またはご家族写真やごきょうだい写真で揃えると、まとまりが良くなります
          </div>
          <img src={img_02} className={styles.img02} alt="img" />
          <div className={styles.tag02}>サイドがソロ写真</div>
          <img src={img_03} className={styles.img02} alt="img" />
          <div className={styles.tag03}>サイドがご家族写真やきょうだい写真</div>
        </div>
        <div className={styles.wrapper02}>
          <div className={styles.tag04}>木製デザインプレート</div>
          <div className={styles.text04}>
            ⚫︎お子様の視線や体の向きが内側へ向くように配置すると、まとまりがよくなります
          </div>
          <div className={styles.text05}>
            ⚫︎隣合うお写真の背景や、被写体の大きさ(アップや引きなど)が異なるように配置すると、バリエーション豊かに見えておすすめです
          </div>
          <div className={styles.wrapper03}>
            <img src={img_04} className={styles.img03} alt="img" />
            <img src={img_05} className={styles.img03} alt="img" />
          </div>
        </div>
        <div
          onClick={() => {
            navigate(-1);
          }}
          className={styles.button0}
        >
          戻る
        </div>
      </div>
    </>
  );
};

export default PointButtonPage;
